/**
 * Styles shared across the puzzle set. Kept in one file so a visual tweak lands on all ten at
 * once — ten near-identical tile styles is exactly how a challenge set drifts into looking like
 * ten different products.
 */

/** A parking bay / gate slot outline in its resting state. */
export const slotIdle = 'tw:border-2 tw:border-white tw:bg-white/50';

/** The bay the customer is being asked to reach. */
export const slotTarget = 'tw:border-2 tw:border-dashed tw:border-primary tw:bg-primary-light';

/** A correctly answered slot. */
export const slotCorrect = 'tw:border-2 tw:border-success tw:bg-success/10';

/** A slot the customer got wrong; pairs with the shake animation. */
export const slotWrong = 'tw:border-2 tw:border-error tw:bg-error/10';

export const slotBase = [
  'tw:absolute tw:box-border tw:rounded-4',
  'tw:transition-colors tw:duration-150',
].join(' ');

/** Tappable tile (vehicle grids, slot chips, traffic-light answers). */
export const tileBase = [
  'tw:flex tw:items-center tw:justify-center tw:box-border',
  'tw:cursor-pointer tw:rounded-8 tw:border-2 tw:transition-colors',
  'tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-primary',
].join(' ');

export const tileIdle = 'tw:border-gray-light tw:bg-white tw:hover:bg-gray-lighter';
export const tileCorrect = 'tw:border-success tw:bg-success/10';
export const tileWrong = 'tw:border-error tw:bg-error/10';

/** Applied to whichever element should shake on a wrong answer. */
export const shakeAnimation = 'tw:animate-[pb-captcha-shake_0.3s]';

/** The draggable piece's focus ring — it is a div, so it needs an explicit one. */
export const draggableCar = [
  'tw:absolute tw:left-0 tw:top-0 tw:z-2 tw:h-[72px] tw:w-[46px]',
  'tw:cursor-grab tw:touch-none tw:rounded-[14px]',
  'tw:focus-visible:outline-3 tw:focus-visible:outline-offset-[3px] tw:focus-visible:outline-primary-darker',
].join(' ');

/** Slider track shared by 1c and 1d. */
export const sliderTrack = [
  'tw:relative tw:mx-auto tw:box-border tw:h-[44px] tw:w-[312px]',
  'tw:rounded-full tw:border tw:border-gray-light tw:bg-gray-lighter',
].join(' ');

export const sliderLabel = [
  'tw:pointer-events-none tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center',
  'tw:text-12 tw:font-regular tw:text-gray-dark',
].join(' ');

export const sliderHandle = [
  'tw:absolute tw:-left-px tw:-top-px tw:flex tw:h-[44px] tw:w-[44px] tw:items-center tw:justify-center',
  'tw:cursor-grab tw:touch-none tw:rounded-full tw:bg-primary tw:text-white',
  'tw:shadow-[0_2px_8px_rgba(38,48,61,0.3)]',
  'tw:focus-visible:outline-3 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-primary-darker',
].join(' ');
